import { api } from "./api";

export const aiVerifiedInvoiceListApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/ai-verified-invoices/list`, {
    params,
  });
};

export const aiVerifiedInvoiceViewApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/ai-verified-invoices/read`, {
    params: params,
  });
};

export const verifiedInvoiceListApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/verified-invoices/list`, {
    params,
  });
};

export const verifiedInvoiceViewApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/verified-invoices/read`, {
    params: params,
  });
};

export const flaggedInvoiceListApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/flagged-invoices/list`, {
    params,
  });
};

export const flaggedInvoiceViewApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/flagged-invoices/read`, {
    params: params,
  });
};

export const pendingInvoiceListApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/pending-invoices/list`, {
    params,
  });
};

export const pendingInvoiceViewApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/pending-invoices/read`, {
    params: params,
  });
};

export const rejectedInvoiceListApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/rejected-invoices/list`, {
    params,
  });
};

export const rejectedInvoiceViewApi = (params) => {
  return api.get(`/admin/invoice-verification-v2/rejected-invoices/read`, {
    params: params,
  });
};

export const verifyPendingInvoiceApi = (params) => {
  return api.post(
    `/admin/invoice-verification-v2/pending-invoices/verify`,
    JSON.stringify(params)
  );
};

export const rejectPendingInvoiceApi = (params) => {
  return api.post(
    `/admin/invoice-verification-v2/flagged-invoices/reject`,
    JSON.stringify(params)
  );
};

export const productBatchPricingDropdown = (params) => {
  return api.get(`/admin/product/product-batch-pricing/list`, {
    params,
  });
};

export const updateProductPtrApi = (params) => {
  return api.post(
    `/admin/invoice-verification-v2/pending-invoices/change-ptr`,
    JSON.stringify(params)
  );
};

export const flagAiverifiedInvoiceApi = (params) => {
  return api.post(
    `/admin/invoice-verification-v2/ai-verified-invoices/flag-invoice`,
    JSON.stringify(params)
  );
};
